import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Category from '../components/Category';
import ProjectsVideo from '../components/ProjectsVideo';
import BackArrow from '../components/BackArrow';

import '../css/projects.css';

import modeling1 from '../img/modeling/jamie-sparker-modeling.jpg';
import modeling2 from '../img/modeling/jamie-sparker-movie.png';
import modeling3 from '../img/modeling/side-page.jpg';
import test from '../img/modeling/test-photo.jpeg';

function Headshots() {
  const [popupOn, setPopupOn] = useState(false);
  const [photo, setPhoto] = useState('');
  const [seoAlt, setSeoAlt] = useState('');

  return (
    <Container id='projects'>
      <BackArrow lastPage='/modeling' />
      <Row className='projects-row'>
        <Category
          photo={test}
          routable={false}
          popup={true}
          hover={true}
          image={true}
          setPhoto={setPhoto}
          setPopupOn={setPopupOn}
          setSeoAlt={setSeoAlt}
          seoAlt='yo'
        />
        <Category
          photo={modeling2}
          routable={false}
          popup={true}
          hover={true}
          image={true}
          setPhoto={setPhoto}
          setPopupOn={setPopupOn}
          setSeoAlt={setSeoAlt}
          seoAlt='asdas'
        />
        <Category
          photo={modeling3}
          routable={false}
          popup={true}
          hover={true}
          image={true}
          setPhoto={setPhoto}
          setPopupOn={setPopupOn}
          setSeoAlt={setSeoAlt}
          seoAlt='yo'
        />
        <ProjectsVideo
          seoAlt={seoAlt}
          photo={photo}
          video={false}
          popupOn={popupOn}
          setPopupOn={setPopupOn}
        />
      </Row>
    </Container>
  );
}

export default Headshots;
